import { render, staticRenderFns } from "./left-nav.vue?vue&type=template&id=6de06240&scoped=true&"
import script from "./left-nav.vue?vue&type=script&lang=ts&"
export * from "./left-nav.vue?vue&type=script&lang=ts&"
import style0 from "./left-nav.vue?vue&type=style&index=0&id=6de06240&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de06240",
  null
  
)

export default component.exports